module.exports = __webpack_public_path__ + "img/horizontal_6_1_8011.ab39d311.png";